import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PaymentModal from '../PaymentModal'
import { getCurrencySymbolByCountryCode, getAreaCurrency, TIMEZONE } from 'constants/currency'
import { PLANS, DEFAULT_TEAM_LIMIT, getMergedPlan } from '../../constants/plans'
import UpgradePayModal from 'components/UpgradePayModal/UpgradePayModal'
import { SOURCE_LOGGED_IN, SOURCE_UNKNOWN, ACCOUNT_STATUS } from '../../constants'
import { isMobileMode, PricingMobileModal } from 'components/ProPlans/PricingModalContent'

const PlanPaymentModal = ({
  userProfile,
  planId,
  show,
  onHide,
  history,
  studentData,
  periodProp,
  source = SOURCE_UNKNOWN,
  email
}) => {
  const currency = planId === PLANS.API.id ? '$' : userProfile?.currency || getAreaCurrency(TIMEZONE)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [currentCurrency, setCurrentCurrency] = useState(currency)
  const freeAccount = !userProfile?.productId
  // Suspended accounts have a productId but their subscription is cancelled —
  // they must also go through new-subscription flow, not upgrade
  const isSuspended = userProfile?.status?.toUpperCase() === ACCOUNT_STATUS.SUSPENDED
  const isFormerClassicAccount = Boolean(userProfile?.cancelUrl || userProfile?.updateUrl)
  const preferredPaymentTab =
    userProfile?.provider === 'PADDLE_BILLING' || isFormerClassicAccount ? 'paddle-billing' : 'card'
  const teamSize = userProfile?.teamSize || 0
  const extraTeamMembers = Math.max(0, teamSize - DEFAULT_TEAM_LIMIT)

  useEffect(() => {
    if (planId) {
      setSelectedPlan(getMergedPlan(planId, currentCurrency))
    }
  }, [planId, currentCurrency, periodProp])

  const onCurrencySelected = (newCurrency) => {
    setCurrentCurrency(newCurrency)
    setSelectedPlan(getMergedPlan(planId, newCurrency))
  }

  const onClose = () => {
    onHide()
    setSelectedPlan(null)
  }

  if (!selectedPlan) {
    return null
  }

  if (isMobileMode()) {
    return <PricingMobileModal show={show} onClose={onClose} />
  }

  return (
    <>
      {freeAccount || isSuspended ? (
        <PaymentModal
          show={show}
          onHide={onClose}
          plan={selectedPlan}
          studentData={studentData}
          email={userProfile?.email || email}
          source={userProfile?.email ? SOURCE_LOGGED_IN : source}
          onCurrencySelected={onCurrencySelected}
          periodProp={periodProp}
          extraTeamMembers={extraTeamMembers}
          currentCurrency={currentCurrency}
          preferredTab={preferredPaymentTab}
        />
      ) : (
        <UpgradePayModal
          show={show}
          onHide={onClose}
          periodProp="monthly"
          currentPlanId={userProfile?.productId}
          email={userProfile?.email}
          interval={userProfile?.interval}
          currency={getCurrencySymbolByCountryCode(currentCurrency)}
          history={history}
          upgradePlanId={planId}
          userProfile={userProfile}
        />
      )}
    </>
  )
}

const mapStateToProps = ({ manage }) => ({
  userProfile: manage.userProfile
})

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(PlanPaymentModal)
